import { without } from '@/globals';
import MutationUtils from '@/utils/MutationUtils';

import * as types from './mutation-types';

const mutations = {
  [types.UPDATE_AUDIENCEFILE]: MutationUtils.makeUpdateListStateMutation('audienceFiles'),

  [types.CREATE_AUDIENCEFILE](state, audienceFile) {
    state.newAudienceFile = audienceFile;
  },
  [types.UPDATE_AUDIENCEFILES_LIST](state, audienceFiles) {
    state.audienceFiles = audienceFiles;
  },
  [types.UPDATE_AUDIENCEFILES_TOTAL_COUNT](state, count) {
    state.audienceFilesTotalCount = count;
  },
  [types.SAVE_AUDIENCEFILES](state, audienceFiles) {
    if (!Array.isArray(audienceFiles)) {
      audienceFiles = [audienceFiles];
    }
    audienceFiles.forEach((audienceFile) => {
      if (state.audienceFiles.find((c) => c.id === audienceFile.id) === undefined) {
        state.audienceFiles = [...state.audienceFiles, audienceFile];
      } else {
        state.audienceFiles = [
          ...without(
            state.audienceFiles,
            state.audienceFiles.find((c) => c.id === audienceFile.id),
          ),
          audienceFile,
        ];
      }
    });
  },
  [types.DELETE_AUDIENCEFILE](state, audienceFile) {
    state.audienceFiles = without(state.audienceFiles, audienceFile);
  },
};

export default mutations;
